(ns nl.mediquest.questionnaire-frontend.component.report
  (:require
   [nl.mediquest.questionnaire-frontend.util.lazy
    :refer (lazy-component)]))

(def regeldruk-report-panel
  (lazy-component
   nl.mediquest.questionnaire-frontend.component.report.regeldruk/panel))

(def vitaliteitsscan-report-panel
  (lazy-component
   nl.mediquest.questionnaire-frontend.component.report.vitaliteitsscan/panel))

(def mijn-positieve-gezondheid-report-panel
  (lazy-component
   nl.mediquest.questionnaire-frontend.component.report.mijn-positieve-gezondheid/panel))

(defn no-report-panel [questionnaire-id]
  [:div.m-4
   [:p.text-xl "Geen rapportage geconfigureerd voor " questionnaire-id]])

(defn panel [questionnaire-id data]
  (case questionnaire-id
    "regeldruk" [regeldruk-report-panel data]
    "vitaliteitsscan" [vitaliteitsscan-report-panel data]
    "mijn-positieve-gezondheid"
    [mijn-positieve-gezondheid-report-panel {:data data :category :adult :show-reflection-questions? true}]
    "mijn-positieve-gezondheid-jongeren"
    [mijn-positieve-gezondheid-report-panel {:data data :category :adolescent}]
    "mijn-positieve-gezondheid-kind"
    [mijn-positieve-gezondheid-report-panel {:data data :category :child}]
    "mijn-positieve-gezondheid-volgbaar"
    [mijn-positieve-gezondheid-report-panel {:data data :category :adult :show-reflection-questions? false}]
    "mijn-positieve-gezondheid-eenvoudig"
    [mijn-positieve-gezondheid-report-panel {:data data :category :simplified :show-reflection-questions? false}]
    [no-report-panel questionnaire-id]))
